<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('retailSale.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('retailSale.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button
            outline
            color="info"
            @click="$router.push({ name: 'retail-sale-create' })"
            >{{ $t('add_new') }}</ts-button
          >
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
        <!-- drawer -->
        <a-drawer
          :title="$t('invoice.filter')"
          placement="right"
          :closable="false"
          :visible="visible"
          @close="() => (visible = false)"
          :zIndex="1020"
          width="300px"
        >
          <div class="row">
            <div class="col-md-12">
              <label>{{ $t('retailSale.branchName') }}</label>
              <div class="form-group">
                <a-select
                  style="width: 257px"
                  v-model="branch_id"
                  :options="branchs"
                  showSearch
                  mode="multiple"
                  :filterOption="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                  :maxTagCount="1"
                  :maxTagTextLength="17"
                  :placeholder="$t('all')"
                >
                </a-select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>{{ $t('retailSale.invoiceDate') }}</label>
                <a-range-picker
                  :allowClear="false"
                  format="DD-MM-YYYY"
                  :defaultValue="rangeDate"
                  :defaultPickerValue="rangeDate"
                  @change="dateRangeChange"
                >
                  <template slot="renderExtraFooter"></template>
                </a-range-picker>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <a-radio-group v-model="is_deleted" @change="fetchData">
                  <a-radio-button :value="undefined">
                    All
                  </a-radio-button>
                  <a-radio-button :value="0">
                    Active
                  </a-radio-button>
                  <a-radio-button :value="1">
                    Voided
                  </a-radio-button>
                </a-radio-group>
              </div>
            </div>
          </div>
        </a-drawer>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <Table
          :columns="columns"
          :data="resources"
          size="small"
          :loading="loading"
          max-height="700"
          highlight-row
          stripe
        >
          <template slot="branchName" slot-scope="{ row }">
            {{ row.branch.branch_name_en }}
          </template>
          <template slot="student" slot-scope="{ row }">
            {{ row.student ? row.student.full_name_en : null }}
          </template>
          <template slot="payment_method" slot-scope="{ row }">
            {{ row.payment_method ? row.payment_method.payment_method : '' }}
          </template>
          <template slot="bank" slot-scope="{ row }">
            <p
              class="ts-font-semibold ts-text-blue-600"
              v-if="row.payment_method_id != 1"
            >
              {{
                row.bank_account
                  ? row.bank_account.bankprofile
                    ? row.bank_account.bankprofile.bank_name
                    : ''
                  : ''
              }}
            </p>
            <p v-if="row.payment_method_id != 1">
              <span
                class="ts-bg-gray-500 ts-px-1 ts-rounded-lg ts-text-white ts-text-xs"
                >{{
                  row.bank_account
                    ? row.bank_account.bankprofile
                      ? row.bank_account.account_name +
                        '|' +
                        row.bank_account.account_number
                      : ''
                    : ''
                }}</span
              >
            </p>
          </template>
          <template slot-scope="{ row }" slot="actions">
            <a href="#" class="text-danger mr-2" @click.prevent="viewPdf(row)">
              <i class="fas fa-file-pdf"></i>
            </a>
            <a
              v-if="!row.is_deleted"
              href="#"
              @click.prevent="deleteRecord(row)"
              :disabled="row._deleting"
            >
              <i class="fas fa-circle-notch spin ml-2" v-if="row._deleting"></i>
              <i class="fa fa-trash ml-2 text-red" v-else></i>
            </a>
          </template>
        </Table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <a-modal
        v-model="pdfModal"
        :title="$t('pdf')"
        @cancel="() => (pdfModal = false)"
        width="70%"
        :maskClosable="false"
        :footer="null"
        :zIndex="1020"
      >
        <preview-pdf-component :src="src" :waiting="waiting" />
      </a-modal>
    </ts-card>
  </div>
</template>
<script>
import moment from 'moment'
import { Errors } from 'form-backend-validation'
import { debounce } from 'lodash'
import { mapActions, mapState } from 'vuex'
import PreviewPdfComponent from './components/pdf-preview'
import Reason from './components/reason_delete'

export default {
  name: 'retailSale',
  components: {
    PreviewPdfComponent
  },
  data() {
    return {
      model: {
        void_reason: null
      },
      errors: new Errors(),
      visible: false,
      rangeDate: [moment(), moment()],
      branchs: [],
      loading: false,
      pdfModal: false,
      waiting: false,
      src: null
    }
  },
  created() {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchData()
    this.getBranch()
  },
  computed: {
    ...mapState('retailSale', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.retailSale.search
      },
      set(newValue) {
        this.$store.commit('retailSale/SET_SEARCH', newValue)
        this.$store.commit('retailSale/RESET_CURRENT_PAGE')
      }
    },
    branch_id: {
      get() {
        return this.$store.state.retailSale.branch_id
      },
      set(newValue) {
        this.$store.commit('retailSale/SET_BRANCH_ID', newValue)
      }
    },
    is_deleted: {
      get() {
        return this.$store.state.retailSale.is_deleted
      },
      set(newValue) {
        this.$store.commit('retailSale/SET_IS_DELETED', newValue)
      }
    },
    columns() {
      return [
        {
          title: this.$t('retailSale.branchName'),
          slot: 'branchName',
          align: 'left',
          width: 170
        },
        {
          title: this.$t('retailSale.date'),
          key: 'stock_out_date',
          align: 'left',
          width: 110
        },
        {
          title: this.$t('retailSale.invoiceNumber'),
          key: 'invoice_no',
          align: 'left',
          width: 140
        },
        {
          title: this.$t('retailSale.student'),
          slot: 'student',
          align: 'left',
          width: 180
        },
        {
          title: this.$t('retailSale.vatAmount'),
          key: 'vat_amount',
          align: 'right',
          width: 120
        },
        {
          title: this.$t('retailSale.subTotal'),
          key: 'sub_total',
          align: 'right',
          width: 120
        },
        {
          title: this.$t('retailSale.grandTotal'),
          key: 'grand_total',
          align: 'right',
          width: 120
        },
        {
          title: this.$t('retailSale.paymentMethod'),
          slot: 'payment_method',
          align: 'left',
          width: 170
        },
        {
          title: this.$t('retailSale.bank'),
          slot: 'bank',
          align: 'left',
          width: 170
        },
        {
          title: this.$t('retailSale.voidReason'),
          key: 'void_reason',
          align: 'left',
          width: 170
        },
        {
          title: this.$t('retailSale.createdBy'),
          key: 'created_by_user',
          align: 'left',
          width: 170
        },
        {
          title: this.$t('retailSale.createdAt'),
          key: 'created_date',
          align: 'left',
          width: 170
        },
        {
          title: this.$t('retailSale.modifiedBy'),
          key: 'modified_by_user',
          align: 'left',
          width: 170
        },
        {
          title: this.$t('retailSale.modifiedAt'),
          key: 'modified_date',
          align: 'left',
          width: 170
        },
        {
          title: this.$t('actions'),
          slot: 'actions',
          fixed: 'right',
          align: 'center',
          width: 110
        }
      ]
    }
  },
  methods: {
    ...mapActions('retailSale', ['destroy']),
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'retailSale/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    getBranch() {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    dateRangeChange(dateRange) {
      this.$store.commit(
        'retailSale/SET_DATE_FROM',
        dateRange[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'retailSale/SET_DATE_TO',
        dateRange[1].format('DD-MM-YYYY')
      )
      this.fetchData()
    },
    viewPdf(row) {
      this.pdfModal = true
      this.waiting = true
      this.$store
        .dispatch('retailSale/pdf', row.stock_out_id)
        .then(response => {
          this.src = response.url + '#zoom=130'
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    deleteRecord(record) {
      this.model.void_reason = null
      this.$confirm({
        title: this.$t('are_you_sure_to_delete'),
        content: h =>
          h(Reason, {
            props: {
              value: this.model,
              validate: this.errors,
              placeholder: this.$t('retailSale.leaveReason')
            }
          }),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        onOk: () => {
          return this.destroy({
            id: record.stock_out_id,
            data: this.model
          })
            .then(response => {
              this.$toasted.success(response.message)
              this.fetchData()
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.message)
              this.errors = new Errors(error.errors)
              return Promise.reject(error)
            })
        },
        onCancel() {}
      })
    },
    edit(record) {
      this.$store.commit('retailSale/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'retail-sale-edit',
        params: { id: record.stock_out_id }
      })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search, branch_id: this.branch_id })
    }, 500),
    branch_id: debounce(function(value) {
      this.fetchData({ branch_id: value })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('retailSale/RESET_STATE')
    next()
  }
}
</script>
